import BaseType from "./BaseType";
import Scenes from "oc-threejs/Scenes";
import AGriff from "../arrangement/Griff";

export default class Griff extends BaseType(THREE.Group) {

    model: ?THREE.Object3D;

    constructor(vsData) {
        super(vsData);
    }

    vsUpdate() {
        this.position.copy(this.vsData.position);
        this.quaternion.copy(this.vsData.quaternion);
        if (this.isVsChanged('artikelnummer')) {
            Scenes.remove(this.model);
            this.loadOBJ({
                artikelnummer: this.vsData.artikelnummer,
                showDummy: false,
                callback: (object, data) => {
                    Scenes.remove(this.model);
                    this.model = object;
                    object.quaternion.copy(data?.quaternion ?? AGriff.defaultQuaternion);
                    object.position.set(0, 0, 0);
                    Scenes.remove(object);
                    const box = Scenes.boundingBox(object);
                    object.position.add(box.getCenter().multiplyScalar(-1));
                    object.position.z = -box.min.z;
                    this.add(object);
                }
            });
        }
    }

}
